import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../../../stores/authStore'
import { GroupsPage } from '../../../features/admin/GroupsPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/groups')({
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (role !== 'admin') {
      throw redirect({ to: '/admin' })
    }
  },
  component: AdminGroupsRoute,
})

/* ───── Route Component ───── */

function AdminGroupsRoute() {
  return <GroupsPage />
}
